import { EntidadeBase } from 'hay-core-react';
class UsuarioEventoModel extends EntidadeBase {
    constructor() {
        super('usuarioevento');
    }
}
const instance = new UsuarioEventoModel();
export default instance;
